import "./Navbar.scss";

const Navbar = ({ title, right }) => (
  <div className="navbar">
    <div className="navbar__content">
      <h1 className="title">{title}</h1>

      {right}
    </div>
  </div>
);

export default Navbar;
